module.exports = __webpack_public_path__ + "static/media/Stech_Logos.67d6fabf.zip";